module.exports = __webpack_public_path__ + "static/media/bima.fdcbc13f.jpeg";